<template>
    <!-- class="avatar-uploader" -->
    <el-upload
        class="uploadBox"
        :action="action"
        :show-file-list="false"
        :data="data"
        :headers="headers"
        :on-success="onSuccess"
        :before-upload="beforeUpload"
    >
        <i class="el-icon-close close" v-if="imageUrl && resetIcon" @click.stop="resetImg"></i>
        <img v-if="imageUrl" :src="imageUrl" class="myAvatar" />
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
</template>

<script>
import baseURL from '@/request/url.js';
import { apiSetVipstoredel } from '@/request/api';
export default {
    data() {
        return {
            closeOnOff: false
        };
    },
    props: {
        action: {
            type: String,
            default: `${baseURL}uploadOss_img`
        },
        data: {
            type: Object,
            default: () => {
                return {};
            }
        },
        headers: {
            type: Object,
            default: () => {
                return {
                    Authorization: `Bearer ${sessionStorage.getItem('userToken')}`
                };
            }
        },
        imageUrl: {
            type: String,
            default: ''
        },
        // 上传成功的钩子
        onSuccess: {
            type: Function,
            default: (v) => {}
        },
        // 上传前的钩子
        beforeUpload: {
            type: Function
        },
        resetIcon: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        resetImg() {
            this.$emit('resetImg', '');
        }
    }
};
</script>

<style lang="scss">
.uploadBox {
    position: relative;
    .close {
        position: absolute;
        right: 10px;
        bottom: 10px;
        font-size: 25px;
        z-index: 99;
        color: #ccc;
    }
    .el-upload {
        display: flex;
        align-items: center;
    }
    .myAvatar {
        height: 178px;
        width: 178px;
        // display: block;
    }
}
</style>
